/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m3.966 5.1713-.9678 5.6324C3.8812 10.2926 4.9064 10 6 10c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6-6-2.6863-6-6c0-.4419.0478-.8726.1384-1.2874L2.0345 4.6362l.0217-.0618a3.14 3.14 0 0 0 .023-.07c.0766-.2393.2724-.85.7214-1.3782C3.3555 2.4733 4.2236 2 5.5 2c1.1319 0 1.9603.5157 2.5053 1.0776.2647.2729.47.5629.624.8272h6.7415c.1539-.2643.3592-.5543.6239-.8272C16.5397 2.5156 17.3681 2 18.5 2c1.3004 0 2.1712.5163 2.7168 1.1948.4335.5391.6292 1.1643.7036 1.4018.0099.0316.0176.0563.0235.073l.0212.0608 1.8924 9.9636c.0933.4204.1425.8575.1425 1.306 0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6c1.089 0 2.1103.2901 2.9907.7973l-.9564-5.5303c-.0129-.0382-.0253-.0756-.0375-.1124-.0854-.2578-.1607-.4853-.3386-.7066C19.4954 4.2457 19.1997 4 18.5 4c-.4681 0-.8064.1986-1.0697.47-.2805.2892-.4389.6294-.4864.7651l-.2344.6697H13V9c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.9048H7.2905l-.2344-.6697c-.0474-.1357-.206-.4759-.4864-.765C6.3064 4.1986 5.9681 4 5.5 4c-.7236 0-1.0221.241-1.1756.4215-.174.2048-.2471.4208-.3335.6762l-.025.0736ZM10 16c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Zm12 0c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Z"
    clipRule="evenodd"
  />,
  'MenuObserve'
);
